import { GET_MODELS_API } from '../utils/api';

export const LOAD_MODELS_REQUEST = '@MODELS/LOAD_MODELS_REQUEST';
export type MODELS_REQUEST = typeof LOAD_MODELS_REQUEST;

export const REZET_MODELS_REQUEST = '@MODELS/REZET_MODELS_REQUEST';
export type REZET_MODELS = typeof REZET_MODELS_REQUEST;


export interface load_MODELS {
    type: MODELS_REQUEST;
    payload: {
        models: null,
    }
}

export async function loadMODELS(body: any): Promise<load_MODELS> {
    try {
        const response = await GET_MODELS_API(body);
        return {
            type: LOAD_MODELS_REQUEST,
            payload: {
                models: response.data
            }
        };
    } catch (error) {
        return {
            type: LOAD_MODELS_REQUEST,
            payload: {
                models: Object(error)
            }
        }
    }
}

export interface zeroModels {
    type: REZET_MODELS;
    payload: {
        models: null,
    }
}

export function resetModels(): zeroModels {
    return {
        type: REZET_MODELS_REQUEST,
        payload: {
            models: null
        }
    }
}